import { get, patch, post } from "../utils/http.util";

const BASE_URL = process.env.REACT_APP_API_URL ?? 'https://dev-api.degencoinflip.com/v2';

export const getCommunity = async (slug: any) => {
  const url = `${BASE_URL}/communities/${slug}`
  const response = await get(url);
  return response?.payload;
};

export const listCommunities = async () => {
  const url = `${BASE_URL}/communities`
  const response = await get(url);
  return response?.payload;
};

export const updateCommunity = async (
  slug: any,
  communityUpdates: any,
  signature: any,
  Authorization: any
) => {
  const url = `${BASE_URL}/communities/${slug}`
  const response = await patch(url, { ...communityUpdates, signature }, { Authorization });
  return response?.payload;
};

export const createCommunity = async (community: any, signature: any, Authorization: any) => {
  const url = `${BASE_URL}/communities`
  const response = await post(url, { ...community, signature }, { Authorization });
  return response?.payload;
};

export const disableCommunity = async (slug: any, signature: any, Authorization: any) => {
  const url = `${BASE_URL}/communities/${slug}/disable`
  const response = await post(url, { signature }, { Authorization });
  return response?.payload;
};
